import { jsx as e } from "react/jsx-runtime";
import { colors as p } from "@silversea-ssc/design-system-tokens";
import { Icon as t } from "../Icon/Icon.js";
const i = "Logo-module_wrapper__KNKoU",
  l = "Logo-module_icon__WB4Xe",
  r = {
    wrapper: i,
    icon: l
  },
  _ = _ref => {
    let {
      width: o = 200,
      mobileWidth: s = 130,
      color: c = "white"
    } = _ref;
    const n = {
      "--icon-color": p[c],
      "--icon-desktop-width": "".concat(o, "px"),
      "--icon-mobile-width": "".concat(s || o, "px")
    };
    return /* @__PURE__ */e("div", {
      style: n,
      children: /* @__PURE__ */e(t, {
        name: "logo",
        className: r.icon,
        wrapperClassName: r.wrapper,
        padding: !1
      })
    });
  };
export { _ as Logo, _ as default };